import ChargeVehicleListView from '../../components/ChargeVehicleListView';

function ChargeVehicleListScreen(props) {
  return (
    <div className="container-fluid px-4 my-4">
      <ChargeVehicleListView />
    </div>
  );
}

export default ChargeVehicleListScreen;
